import { render, staticRenderFns } from "./BookLibrary.vue?vue&type=template&id=039df9f8&scoped=true"
import script from "./BookLibrary.vue?vue&type=script&lang=js"
export * from "./BookLibrary.vue?vue&type=script&lang=js"
import style0 from "./BookLibrary.vue?vue&type=style&index=0&id=039df9f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039df9f8",
  null
  
)

export default component.exports